'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import { EERIE } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import VideoIcon from '../Icons/VideoIcon';
import QuizIcon from '../Icons/QuizIcon';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
const StyledList = styled(UIList).withConfig({
  displayName: "ContentOverview__StyledList",
  componentId: "qkl9cq-0"
})(["position:relative;left:-4px;font-weight:400 !important;"]);
const OverviewUIIcon = styled(props => /*#__PURE__*/_jsx(UIIcon, Object.assign({
  color: EERIE,
  size: 24
}, props))).withConfig({
  displayName: "ContentOverview__OverviewUIIcon",
  componentId: "qkl9cq-1"
})(["position:relative;top:4px;margin-right:4px !important;"]);

const ContentOverview = ({
  content,
  hasCertificate,
  hasStudyGuide
}) => {
  const videos = useMemo(() => content.filter(c => c.contentType === 'VIDEO').length, [content]);
  const quizzes = useMemo(() => content.filter(c => c.contentType === 'QUIZ').length, [content]);
  const practicalExercises = useMemo(() => content.filter(c => c.contentType === 'PRACTICAL_EXERCISE_FLOW').length, [content]);
  const links = useMemo(() => content.filter(c => c.contentType === 'LINK').length, [content]);
  return /*#__PURE__*/_jsxs(StyledList, {
    inline: true,
    children: [!!hasCertificate && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(OverviewUIIcon, {
        name: "certification"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.mostPopularCertificates.numCertifications.singular"
      })]
    }), !!videos && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(VideoIcon, {
        className: "m-right-1",
        style: {
          position: 'relative',
          top: 6
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.mostPopularCertificates.numVideos.${videos > 1 ? 'plural' : 'singular'}`,
        options: {
          number: videos
        }
      })]
    }), !!quizzes && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(QuizIcon, {
        className: "m-right-1",
        style: {
          position: 'relative',
          top: 6
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.mostPopularCertificates.numQuizzes.${quizzes > 1 ? 'plural' : 'singular'}`,
        options: {
          number: quizzes
        }
      })]
    }), !!practicalExercises && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(OverviewUIIcon, {
        name: "registration"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.mostPopularCertificates.numPracticalExercises.${practicalExercises > 1 ? 'plural' : 'singular'}`,
        options: {
          number: practicalExercises
        }
      })]
    }), (!!links || !!hasStudyGuide) && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(OverviewUIIcon, {
        name: "salesTemplates"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.mostPopularCertificates.resources"
      })]
    })]
  });
};

export default ContentOverview;